import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { StyleService } from "app/infrastructure/services/style.service";
import { EntityChildElement } from "../entityWithChilds/model/EntityChildElement";
import { EntitiesService } from "../service/entities.service";
import { EntityChildsContext } from "../entityWithChilds/model/EntityChildsContext";
import { ActivatedRoute } from "@angular/router";
import { SxContextService } from "app/infrastructure/services/sxContext.service";
import { EntitiesInformationService } from "app/private/sidebar-information/entity-information.service";
import { BaseComponent } from "app/helpers/components/base/base.component";

@Component({
  selector: "entity-list-component",
  templateUrl: "./entity-list.component.html"
})
export class EntityListComponent extends BaseComponent
  implements OnInit, OnDestroy {
  @Input("organizationList") organizationList: EntityChildElement[];
  entityselectChild: EntityChildElement = {
    context: undefined,
    description: null,
    title: null,
    childs: [],
    entityType: null,
    categories: [],
    actions: null,
    route: null,
    created: null,
    creationDate: null,
    entityCode: null,
    descripcionExt: null
  };
  entitySelectChildCache: EntityChildElement;
  context: EntityChildsContext;

  constructor(
    private styleService: StyleService,
    private entitiesService: EntitiesService,
    public informationService: EntitiesInformationService,
    private sxContext: SxContextService,
    private aRoute: ActivatedRoute
  ) {
    super(informationService);
  }

  ngOnInit() {
    this.styleService.addStyle(
      "EntityListComponent",
      require("./entity-list.component.css")
    );
    super.ngOnInit();
    this.getData();
  }

  getData() {
    this.sxContext.getContext(this.aRoute).subscribe(context => {
      this.entitiesService.getOrganizationsList(context).subscribe(res => {
        let breadcrumbInfo = {
          description: null,
          created: null,
          creationDate: null,
          showEdit: false
        };
        this.informationService.breadcrumInfo$.next(breadcrumbInfo);
        this.organizationList = res;
        this.organizationList.forEach(element => {
          element.categories = [];
        });

        if (this.organizationList != undefined) this.selectChild(res[0]);
      });
    });
  }

  selectChild(child: EntityChildElement) {
    if (
      child.context.organizationCode === "" &&
      child.context.subscriptionCode === "" &&
      child.context.channelCode === "" &&
      child.context.productCode === ""
    ) {
      this.entityselectChild = child;
      this.entityselectChild.title = "";
    } else {
      this.entitiesService
        .getEntityElements(child.context)
        .subscribe(entity => {
          this.entityselectChild = entity;
          this.entityselectChild.title = entity.title;
        });
    }
  }

  ngOnDestroy() {
    this.styleService.removeStyle("EntityListComponent");
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityList/entity-list.component.ts